module.exports = __webpack_public_path__ + "img/showHow3.30c78c8b.png";